module.exports = __webpack_public_path__ + "static/DSC05285-fa39752e8399b56071f76a9ef82bb9df.jpg";